import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="scroll-mt-24 w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="常见安装问题"
          title="安装、打开、联网问题逐条排查"
          desc="下面整理了下载安装过程中最常遇到的提示与状况，点击问题即可展开对应的处理方法。"
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden h-fit"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-950">
                    {faq.q}
                  </span>
                  <i
                    className={`text-lg shrink-0 transition-transform ${
                      isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen ? (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-xs md:text-sm leading-relaxed text-foreground-600 border-t border-background-200 pt-4">
                      {faq.a}
                    </p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}